import Api from "./Api";
import axios from "axios";
import Session from "@/classes/Session";
import { apiUrl } from "@/config/config";

class sendoutsApi extends Api {

  constructor(version = "v2") {
    super(version);
    let jwt = Session.getJwtCookie();

    this.http = axios.create({
      baseURL: apiUrl + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      Session.logout();
      jwt = "";
    } else {
      this.set_jwt(jwt);
    }
    this.page_length = 25;
  }
  sendEmail() {
  return this.http.post("users/project_allocation_reminder");
  }

}

export default sendoutsApi



// WEBPACK FOOTER //
// ./src/api/Sendouts.js